import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/address';
import { showDialog } from '../../components/common/dialog';

export default {
  langs,
  mixins: [entryMixin],
  model: {
    prop: 'activeAddressKey',
    event: 'change'
  },

  props: {
    /** 地址管理 sdk 实例 */
    addressManagementSdk: Object,
    /** 选择的地址 */
    activeAddressKey: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      /** 地址列表 */
      addressList: [],
      /** 选择的地址 */
      // activeAddressKey: ''
    };
  },

  mounted() {
    this.fetchGetAddressList();
  },

  methods: {
    async fetchGetAddressList() {
      if (!this.addressManagementSdk) return;
      const res = await this.addressManagementSdk.getAddressListOfUser();
      this.addressList = res.contents;
    },
    /**
     * @description: 删除地址
     * @param {object} info
     * @return {void}
     */
    async handleDelete(info, index) {
      if (!this.addressManagementSdk) return;
      showDialog({
        content: this.iarTrans('address.deleteMsg'),
        cancelButtonText: this.iarTrans('common.cancel'),
        confirmButtonText: this.iarTrans('address.deleteConfirmBtnText'),
        onConfirm: async () => {
          await this.addressManagementSdk.deleteAddress({ id: info.id });
          this.addressList.splice(index, 1);
          this.$nextTick(() => {
            if (info.id === this.activeAddressKey) {
              this.handleSelect(this.addressList.length ? this.addressList[0] : {});
              // this.activeAddressKey = this.addressList.length ? this.addressList[0].id : '';
            }
          });
        }
      });
    },
    /**
     * @description: 选择地址
     * @param {object} info
     * @return {void}
     */
    handleSelect(info) {
      this.$emit('change', info.id);
      this.$emit('select', info);
      // this.activeAddressKey = info.id;
    }
  }
};
